module.exports = __webpack_public_path__ + "static/img/45-2.e548450.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/45-2.jpg
// module id = 5M4U
// module chunks = 0